import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { Paper, TextField } from '@mui/material';
import { getSellableProducts, giftCardCreateOrReload } from 'actions/EntityActions';
import { showSnackbar } from 'actions/CommonActions';
import { formInput, addProductToPOSOder } from 'actions/FormActions';
// Basic Components
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import RadioInput from 'screens/components/basic/RadioInput';
import Button from 'screens/components/basic/Button';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import "../styles/POSGiftCardPurchase.css"


class POSGiftCardPurchase extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formattedCardNumber: "",
      formattedCardNumberError: null,
      giftCardProcessError: false,
      productId: "",
      giftCardGroup: [],
      lastCardNumber: ""
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.POSGenericGiftCardPurchaseFailTime === null && this.props.POSGenericGiftCardPurchaseFailTime !== null || prevProps.POSGenericGiftCardPurchaseFailTime !== this.props.POSGenericGiftCardPurchaseFailTime) {
      this.displayGiftCardError();
    }

    if (prevProps.POSGenericGiftCardPurchaseSuccessTime === null && this.props.POSGenericGiftCardPurchaseSuccessTime !== null || prevProps.POSGenericGiftCardPurchaseSuccessTime !== this.props.POSGenericGiftCardPurchaseSuccessTime) {
      this.props.onCancel();
      this.props.showSnackbar(this.props.t('pos.giftcardPurchase.purchase.successMsg', { cardNum: this.props.POSGenericGiftCardPurchaseSuccess.cardNumber, amount: this.props.POSGenericGiftCardPurchaseSuccess.balance }))
      this.clearForm();
    }
  }

  displayGiftCardError = () => {
    this.setState({ giftCardProcessError: true }, () => {
      setTimeout(() => {
        this.setState({ giftCardProcessError: false });
      }, 3000);
    });
  }

  clearForm = () => {
    this.props.formInput("", "POSGiftCardPurchaseCardNumber")
    this.props.formInput(null, "POSGiftCardPurchasetype")
    this.setState({ formattedCardNumber: "" })
  }

  createOrReloadGiftCard = () => {
    const { branchId } = this.props;
    this.state.giftCardGroup.map(card => {
      const balance = parseFloat(card.cardAmount);
      const model = {
        BranchId: branchId,
        CardNumber: card.cardNumber,
        Balance: balance,
        Type: card.newOrReload
      };
      this.props.giftCardCreateOrReload(model);
    })
  }

  handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    let formattedValue = "";
    for (let i = 0; i < value.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += " ";
      }
      formattedValue += value[i];
    }

    this.setState({ formattedCardNumber: formattedValue });
    this.setState({ formattedCardNumberError: !formattedValue });
    this.props.formInput(value, "POSGiftCardPurchaseCardNumber")
  }

  search = () => {
    const filters = {
      page: 1,
      itemsPerPage: 1,
      searchText: this.props.t('common.giftCard'),
      baseCategoryId: "3",
      categoryId: null,
      branchId: this.props.branchId,
      THC_MIN: 0,
      THC_MAX: 100,
      CBD_MIN: 0,
      CBD_MAX: 100,
      SubCategoryId: [],
      Weight: []
    };
    this.props.getProducts(filters);
  }

  closeDialogSearch = () => {
    const filters = {
      page: 1,
      itemsPerPage: 8,
      searchText: null,
      baseCategoryId: "3",
      categoryId: null,
      branchId: this.props.branchId,
      THC_MIN: 0,
      THC_MAX: 100,
      CBD_MIN: 0,
      CBD_MAX: 100,
      SubCategoryId: [],
      Weight: []
    };
    this.props.getProducts(filters);
  }

  confirm = () => {
    const { branchId, cardNumber, paidGenericGiftCardActivationAmount, newOrReload, currentGiftCardActive } = this.props;
    const balance = parseFloat(paidGenericGiftCardActivationAmount);
    const model = {
      BranchId: branchId,
      CardNumber: cardNumber,
      Balance: balance,
      Type: newOrReload,
      OrderProductId: currentGiftCardActive
    };
    if (cardNumber){
      this.props.giftCardCreateOrReload(model);
    }
  }

  render() {
    const { t } = this.props; 
    const { paidGenericGiftCardActivationAmount } = this.props
    const options = [
      {
        text: t('pos.giftcardPurchase.purchase.newCard'),
        value: "1"
      },
      {
        text: t('pos.giftcardPurchase.purchase.reloadCard'),
        value: "2"
      }
    ];

    return (
      <DialogInput
        title={<DialogHeaderWithClose text={t('pos.giftcardPurchase.purchase.giftCardTitle')} handleClose={() => { this.props.onCancel() }}/>}
        actions={[
          <Button
            key={2}
            className="pull-right space"
            name="buttonRefundDialogConfirm"
            label={t('common.confirm')}
            primary={true}
            disabled={this.state.formattedCardNumberError}
            onTouchTap={() => this.confirm()} />]}
        modal={true}
        style={{ zIndex: '980' }}
        open={this.props.show}
        autoScrollBodyContent={true}>
        <div>
          <div>
            <h4>{t('pos.giftcardPurchase.purchase.fillUpInfo')}</h4>
            {this.state.giftCardProcessError ? (
              <h5 style={{ color: 'red', animation: 'slideInOut 5s', fontSize: '20px', fontWeight: 'bold' }}>
                {this.props.POSGenericGiftCardPurchaseFail}
              </h5>
            ) : null}
            <div className="col-lg-12">
              <Paper style={{
                padding: '20px',
                marginBottom: '20px',
                marginTop: '20px',
                borderRadius: '15px',
                background: 'linear-gradient(45deg, #a697e2 30%, #8a73ea 90%)',
                boxShadow: '0 3px 5px 2px rgba(198, 186, 246, .3)'
              }}>
                <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                  <h2 style={{ width: '75%' }}>{t('common.giftCard')}</h2>
                  <h2 style={{ width: '20%', textAlign: 'left', color: "white" }}>{t('pos.giftcardPurchase.purchase.balance')}</h2>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
                  <div style={{ width: '75%' }}>
                    <TextField
                      className="POSGiftCard-input"
                      name={`POSGiftCardPurchaseCardNumber`}
                      fullWidth={true}
                      type="text"
                      floatingLabelText={t('pos.giftcardPurchase.purchase.giftCardNumber')}
                      hintText={t('pos.giftcardPurchase.purchase.enterScanCardNumber')}
                      floatingLabelStyle={{ color: 'white', fontSize: '20px' }}
                      hintStyle={{ color: 'white', fontSize: '20px' }}
                      value={this.state.formattedCardNumber}
                      onChange={this.handleChange}
                      required
                      error={this.state.formattedCardNumberError}
                      helperText={this.state.formattedCardNumberError ? t('pos.giftcardPurchase.purchase.enterCardNum') : ""}
                    />
                  </div>
                  <div style={{ width: '20%', textAlign: 'right' }}>
                    <TextField
                      name={`POSGiftCardPurchaseCardAmount`}
                      fullWidth={true}
                      label={t('pos.giftcardPurchase.purchase.giftCardAmount')}
                      floatingLabelText={t('pos.giftcardPurchase.purchase.giftCardAmount')}
                      hintText={t('pos.giftcardPurchase.purchase.giftCardAmount')}
                      inputStyle={{ color: 'white', fontSize: '20px' }}
                      floatingLabelStyle={{ color: 'white', fontSize: '20px' }}
                      hintStyle={{ color: 'white', fontSize: '20px' }}
                      value={paidGenericGiftCardActivationAmount ? paidGenericGiftCardActivationAmount : "0.00"}
                      disabled={paidGenericGiftCardActivationAmount ? true : false}
                    />
                  </div>
                </div>
              </Paper>
            </div>
            <section>
              <div className="col-lg-12">
                <RadioInput
                  groupName={`POSGiftCardPurchasetype`}
                  options={options}
                  fullWidth={true}
                />
              </div >
            </section>
          </div>
        </div>
      </DialogInput>
    );
  }
}

function mapStateToProps(state) {
  return {
    branchId: state.common.branchId,
    cardNumber: state.form.POSGiftCardPurchaseCardNumber || "",
    newOrReload: state.form.POSGiftCardPurchasetype,
    POSGenericGiftCardPurchaseFail: state.entity.POSGenericGiftCardPurchaseFail,
    POSGenericGiftCardPurchaseFailTime: state.entity.POSGenericGiftCardPurchaseFailTime,
    sellableProducts: state.entity.sellableProducts || [],
    posOrder: state.entity.posOrder,
    paidGenericGiftCardActivationAmount: state.form.paidGenericGiftCardActivationAmount,
    POSGenericGiftCardPurchaseSuccessTime: state.entity.POSGenericGiftCardPurchaseSuccessTime,
    POSGiftCardPurchaseCardNumber: state.form.POSGiftCardPurchaseCardNumber,
    genericGiftCardProcessedList: state.form.genericGiftCardProcessedList ? state.form.genericGiftCardProcessedList : [],
    currentGiftCardActive: state.form.currentGiftCardActive,
    POSGenericGiftCardPurchaseSuccess: state.entity.POSGenericGiftCardPurchaseSuccess
  };
}

function mapDispatchToProps(dispatch) {
    return {
      giftCardCreateOrReload: (model) => dispatch(giftCardCreateOrReload(model)),
      formInput: (value, name) => dispatch(formInput(value, name)),
      showSnackbar: (message) => dispatch(showSnackbar(message)),
      getProducts: (filters) => dispatch(getSellableProducts(filters))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardPurchase));